import { render } from "./SideBarCard.vue?vue&type=template&id=5499c589&scoped=true"
import script from "./SideBarCard.vue?vue&type=script&lang=js"
export * from "./SideBarCard.vue?vue&type=script&lang=js"

import "./SideBarCard.vue?vue&type=style&index=0&id=5499c589&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5499c589"]])

export default __exports__